import React from "react"
import createReactClass from "create-react-class"
import DocumentTitle from "react-document-title"
import * as shared from "auth/component/shared"
import {Input} from "./body/placeholder"
import onClickOutside from "react-onclickoutside"
import * as Client from "./body/client"
import cx from "classnames"
import * as str from "shared/string"
import {stop} from "shared/event"
import {Label, ErrorMessage} from "../../../../components/inputs"
import {PrimaryButton} from "../../../../components/buttons"
import Exclamation from "../../../../../images/exclamation-icon.svg?react"
import Eyes from "../../../../../images/eyes-looking-right.svg?react"

const zipReady = (zip) => {
  return /^\d{5}(?:[ -]\d{4})?|[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(zip)
}

const conditionZip = (zip) => {
  switch (zip.length) {
    // USA case
    case 10:
    case 5:
      return zip.substring(0, 5)

    // Canada case
    case 6:
      zip = zip.substring(0, 3) + " " + zip.substring(3)
    case 7:
      return zip.replace("-", " ")

    // Shouldn't pass zipReady, just return it
    default:
      return zip
  }
}

const SchoolItem = ({school, onSelectSchool, isHighlighted, isSelected, onMouseEnter}) => {
  const name = school["Name"]
  const optionId = `school-option-${str.toKebab(name)}`
  return (
    <li
      id={optionId}
      className={cx("overline-sm p-4 cursor-pointer", isHighlighted ? "bg-primary-1 text-neutral-20" : "hover:bg-primary-1 hover:text-neutral-20")}
      role="option"
      aria-selected={isSelected ? "true" : "false"}
      onClick={onSelectSchool}
      onMouseEnter={onMouseEnter}
    >
      {name}
    </li>
  )
}

const sortBy = (schools) =>
  schools.sort((a, b) => {
    if (a["Name"] < b["Name"]) {
      return -1
    } else if (a["Name"] > b["Name"]) {
      return 1
    } else {
      return 0
    }
  })

const getActivedescendant = (schools, idx) => `school-option-${str.toKebab(schools[idx].Name)}`

const Container = ({children}) => <div className="absolute inset-x-0 bg-neutral-19 text-sm rounded-xl text-left">{children}</div>

const Schools = onClickOutside(
  createReactClass({
    getInitialState() {
      return {
        highlightedIndex: 0,
        showFocusRing: false,
        showKeyboardHighlight: false,
        userUsedKeyboardNavigation: false
      }
    },
    componentDidMount() {
      // Focus the listbox and show initial keyboard highlight
      if (this.listboxRef) {
        this.setState({showKeyboardHighlight: true})
        this.listboxRef.focus()
      }
    },
    handleClickOutside() {
      this.props.onCloseDropdown()
    },
    onManualSchool(e) {
      this.props.onManualSchool()
      stop(e)
    },
    setHighlightedIndex(idx) {
      this.setState({highlightedIndex: idx}, () => {
        // Scroll the highlighted option into view
        this.scrollToHighlighted(idx)
      })
    },
    scrollToHighlighted(idx) {
      if (this.listboxRef) {
        const highlightedOption = this.listboxRef.children[idx]
        if (highlightedOption) {
          highlightedOption.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest"
          })
        }
      }
    },
    onDownArrow(count) {
      const index = this.state.highlightedIndex
      if (index >= count - 1) {
        this.setHighlightedIndex(0)
      } else {
        this.setHighlightedIndex(index + 1)
      }
    },
    onUpArrow(count) {
      const index = this.state.highlightedIndex
      if (index === 0) {
        this.setHighlightedIndex(count - 1)
      } else {
        this.setHighlightedIndex(index - 1)
      }
    },
    onKeyDown(e) {
      const {schools, onSelectSchool, onResetZip} = this.props
      const count = schools.length
      const highlightedIndex = this.state.highlightedIndex

      // Enable keyboard mode when user uses navigation keys
      const isNavigationKey = ["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(e.key)
      if (isNavigationKey) {
        this.setState({
          showFocusRing: true,
          showKeyboardHighlight: true,
          userUsedKeyboardNavigation: true
        })
      }

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault()
          // If at last item, move focus to manual school button
          if (highlightedIndex >= count - 1) {
            this.focusManualButton()
          } else {
            this.onDownArrow(count)
          }
          break
        case "ArrowUp":
          e.preventDefault()
          this.onUpArrow(count)
          break
        case "Enter":
          e.preventDefault()
          if (schools[highlightedIndex]) {
            onSelectSchool(schools[highlightedIndex])
          }
          break
        case "Escape":
          e.preventDefault()
          this.props.onCloseDropdown()
          break
        case "Tab":
          // Allow normal tab behavior but close dropdown
          this.props.onCloseDropdown()
          break
      }
    },
    focusManualButton() {
      // Move focus to the manual school button
      if (this.manualButtonRef) {
        this.setState({showKeyboardHighlight: false}) // Hide listbox highlight
        this.manualButtonRef.focus()
      }
    },
    onManualButtonKeyDown(e) {
      switch (e.key) {
        case "ArrowUp":
          e.preventDefault()
          // Move focus back to listbox on last item
          if (this.listboxRef) {
            const count = this.props.schools.length
            this.setState({
              showKeyboardHighlight: true,
              highlightedIndex: count - 1
            })
            this.listboxRef.focus()
          }
          break
        case "Escape":
          e.preventDefault()
          this.props.onCloseDropdown()
          break
      }
    },
    onItemMouseEnter() {
      // Switch to mouse mode - hide keyboard highlight but keep logical state
      if (this.state.showKeyboardHighlight) {
        this.setState({
          showFocusRing: false,
          showKeyboardHighlight: false
        })
      }
    },
    render() {
      const highlightedIndex = this.state.highlightedIndex
      const {schools, onSelectSchool, selectedSchool} = this.props
      const sortedSchools = sortBy(schools, (s) => s["Name"])
      const count = sortedSchools.length
      const items = sortedSchools.map((s, idx) => {
        return (
          <SchoolItem
            school={s}
            key={s["Id"]}
            isHighlighted={idx === highlightedIndex && this.state.showKeyboardHighlight}
            isSelected={selectedSchool && selectedSchool["Id"] === s["Id"]}
            onSelectSchool={onSelectSchool.bind(null, s)}
            onMouseEnter={this.onItemMouseEnter}
          />
        )
      })
      return (
        <Container>
          <div role="status" aria-live="polite" className="sr-only">
            {count === 1 ? `1 school found` : `${count} schools found`}
          </div>
          <p className="text-sm py-3 px-4" id="select-school-list">
            Select your school from the list:
          </p>
          <ul
            ref={(ref) => {
              this.listboxRef = ref
            }}
            id="school-list"
            className={cx("bg-neutral-17 text-left max-h-[246px] overflow-auto focus:outline-none", this.state.showFocusRing && "ring-2 ring-primary-1")}
            tabIndex="-1"
            aria-labelledby="select-school-list"
            aria-describedby={this.props.validationErrors?.school ? "school-selection-error" : undefined}
            aria-invalid={this.props.validationErrors?.school ? "true" : "false"}
            role="listbox"
            aria-activedescendant={getActivedescendant(sortedSchools, highlightedIndex)}
            onKeyDown={this.onKeyDown}
          >
            {items}
          </ul>
          <div className="py-3 px-4">
            <button
              ref={(ref) => {
                this.manualButtonRef = ref
              }}
              type="button"
              className="link-underline text-sm font-vs-bold p-0 cursor-pointer"
              onClick={this.onManualSchool}
              onKeyDown={this.onManualButtonKeyDown}
            >
              Click here if you can't find your school.
            </button>
          </div>
        </Container>
      )
    }
  })
)

const SelectedSchool = createReactClass({
  _onClick(e) {
    this.props._onClick()
    stop(e)
  },
  render() {
    const school = this.props.school
    return (
      <div className="mt-10">
        <div className="overline-sm">
          <span>{school["Name"]}</span>
          <button type="button" className="link ml-2 bg-transparent border-none p-0 cursor-pointer" onClick={this._onClick}>
            (undo)
          </button>
        </div>
      </div>
    )
  }
})

const EmptyView = ({children}) => <div className="p-4 flex flex-col text-center gap-y-3 min-h-[116px]">{children}</div>

const NoSchools = createReactClass({
  _onClick(e) {
    this.props.onManualSchool()
    stop(e)
  },
  render() {
    return (
      <Container>
        <EmptyView>
          <div className="w-6 h-6 mx-auto">
            <Exclamation />
          </div>
          <div className="text-sm">
            We failed to find a school in that ZIP. Try another one, or{" "}
            <button type="button" className="link-underline bg-transparent border-none p-0 cursor-pointer" onClick={this._onClick}>
              type your own school name
            </button>
            .
          </div>
        </EmptyView>
      </Container>
    )
  }
})

const LoadingSchools = createReactClass({
  render() {
    return (
      <Container>
        <div role="status" aria-live="polite" className="sr-only">
          Searching for schools in your area...
        </div>
        <EmptyView>
          <div className="w-6 h-6 mx-auto">
            <Eyes />
          </div>
          <span className="text-sm">Finding schools in your area...</span>
        </EmptyView>
      </Container>
    )
  }
})

const ManualSchool = ({onSchoolNameChange, validationErrors}) => (
  <div className="mt-10">
    <label>
      <Label>Type your school's name</Label>
      <Input
        type="text"
        name="school_name"
        onChange={onSchoolNameChange}
        aria-invalid={validationErrors.schoolName ? "true" : "false"}
        aria-describedby={validationErrors.schoolName ? "schoolName-error" : undefined}
        autoFocus
      />
      {validationErrors.schoolName && <ErrorMessage id="schoolName-error">{validationErrors.schoolName}</ErrorMessage>}
    </label>
  </div>
)

const School = createReactClass({
  render() {
    let view
    // Weirdly, destructuring school and manual from this.props doesn't work!
    const school = this.props.school
    const manual = this.props.manualSchool
    const {onSchoolNameChange, onTryAgain, onResetZip, onSelectSchool, onManualSchool, onCloseDropdown, validationErrors} = this.props
    if (manual) {
      view = <ManualSchool onSchoolNameChange={onSchoolNameChange} validationErrors={validationErrors} />
    } else if (school) {
      view = <SelectedSchool school={school} _onClick={onTryAgain} />
    } else {
      const schools = this.props.schools /* test with an array of school objects */
      if (!schools) {
        view = <LoadingSchools />
      } else if (schools.length > 0) {
        view = (
          <Schools
            schools={schools}
            selectedSchool={school}
            onResetZip={onResetZip}
            onCloseDropdown={onCloseDropdown}
            onSelectSchool={onSelectSchool}
            onManualSchool={onManualSchool}
            validationErrors={validationErrors}
          />
        )
      } else {
        view = <NoSchools onManualSchool={onManualSchool} />
      }
    }
    return view
  }
})

export default createReactClass({
  defaultState: {
    zip: "",
    schoolNameValidated: false,
    schoolName: "",
    schools: null,
    loadingSchools: false,
    school: null,
    manualSchool: false,
    errors: {},
    submitAttempted: false,
    validationErrors: {},
    showDropdown: false
  },
  getInitialState() {
    return this.defaultState
  },
  onResetZip() {
    this.setState({
      schoolNameValidated: false,
      schoolName: "",
      zip: "",
      schools: null,
      loadingSchools: false,
      school: null,
      manualSchool: false
    })
  },
  onCloseDropdown() {
    // Close dropdown without clearing the ZIP input or schools data
    this.setState({
      showDropdown: false,
      school: null,
      manualSchool: false
    })
  },
  isValid() {
    const {school, schoolNameValidated, zip} = this.state
    return school || (schoolNameValidated && zipReady(zip))
  },
  hideButton() {
    // Prevents the finish button from appearing over the top of the schools.
    const {schools, showDropdown} = this.state
    return showDropdown && schools && schools.length > 0 && !this.isValid()
  },
  onZipChange(e) {
    var zip = e.target.value.toUpperCase()
    if (zipReady(zip)) {
      zip = conditionZip(e.target.value)
      if (!this.state.loadingSchools) {
        this.setState({zip: zip, loadingSchools: true})
        const self = this
        Client.searchSchools(zip, (err, res) => {
          if (err) {
            throw new Error("Unknown error when changing zip: " + err)
          } else if (res) {
            self.setState({
              schools: res.body || [],
              showDropdown: true,
              loadingSchools: false,
              validationErrors: {...self.state.validationErrors, zip: undefined}
            })
          }
        })
      }
    } else {
      this.setState({
        zip: zip,
        loadingSchools: false,
        schools: null,
        school: null,
        schoolNameValidated: false,
        schoolName: "",
        manualSchool: false,
        showDropdown: false
      })
    }
  },
  onSelectSchool(school) {
    this.setState({
      school: school,
      schoolSelectionAnnouncement: `Selected ${school["Name"]}`,
      showDropdown: false
    })
    // Clear the announcement after a brief delay
    setTimeout(() => {
      this.setState({schoolSelectionAnnouncement: ""})
    }, 1000)
  },
  onManualSchool() {
    this.setState({
      school: null,
      manualSchool: true,
      showDropdown: false
    })
  },
  onTryAgain() {
    this.setState({school: null})
  },
  onSchoolNameChange(e) {
    const name = e.target.value
    this.setState({
      schoolName: name,
      schoolNameValidated: name !== ""
    })
  },
  onSubmit(e) {
    e.preventDefault()
    e.stopPropagation()

    if (!this.isValid()) {
      this.showValidationErrors()
      this.setState({submitAttempted: true})
      return
    }

    // Form is valid, submit normally
    const form = e.target
    form.submit()
  },
  showValidationErrors() {
    const {zip, school, schoolName, manualSchool} = this.state
    const validationErrors = {}

    if (!zipReady(zip)) {
      validationErrors.zip = "Please enter a valid ZIP code."
    } else if (!school && !manualSchool) {
      validationErrors.school = "Please select a school from the list or enter your school name manually."
    } else if (manualSchool && !schoolName.trim()) {
      validationErrors.schoolName = "Please enter your school's name."
    }

    this.setState({validationErrors})
  },
  render() {
    const {zip, school, schools, manualSchool} = this.state
    let schoolView
    if (zipReady(zip) && (this.state.showDropdown || school || manualSchool)) {
      schoolView = (
        <School
          school={school}
          schools={this.state.showDropdown ? schools : null}
          manualSchool={manualSchool}
          onManualSchool={this.onManualSchool}
          onSelectSchool={this.onSelectSchool}
          onSchoolNameChange={this.onSchoolNameChange}
          onResetZip={this.onResetZip}
          onCloseDropdown={this.onCloseDropdown}
          onTryAgain={this.onTryAgain}
          validationErrors={this.state.validationErrors}
        />
      )
    }
    return (
      <DocumentTitle title="Select School: Banzai">
        <shared.Page>
          <shared.Main>
            <shared.Panel className="h-[76vh] !justify-normal">
              <div className="grid gap-y-12">
                <shared.Textbox>
                  <div className="body-lg lg:text-xl font-vs-medium">Help us find your school.</div>
                  <shared.Explanation>Complete the signup process by providing the ZIP code of the school you teach at.</shared.Explanation>
                </shared.Textbox>
                <form method="POST" action="/teacher/select/school" onSubmit={this.onSubmit}>
                  <div role="status" aria-live="polite" className="sr-only">
                    {this.state.schoolSelectionAnnouncement}
                  </div>
                  <div className="relative">
                    <label>
                      <Label>School Zip Code</Label>
                      <Input
                        type="text"
                        maxLength={10}
                        name="zip"
                        className="zip"
                        onChange={this.onZipChange}
                        value={zip}
                        aria-expanded={zipReady(zip) && schools && schools.length > 0 ? "true" : "false"}
                        aria-controls={zipReady(zip) && schools && schools.length > 0 ? "school-list" : undefined}
                        aria-autocomplete="list"
                        role="combobox"
                        aria-activedescendant={
                          zipReady(zip) && schools && schools.length > 0 && this.state.showDropdown && schools[this.state.highlightedIndex || 0]
                            ? getActivedescendant(sortBy(schools), this.state.highlightedIndex || 0)
                            : undefined
                        }
                        aria-invalid={this.state.validationErrors.zip ? "true" : "false"}
                        aria-describedby={this.state.validationErrors.zip ? "zip-error" : undefined}
                      />
                      {this.state.validationErrors.zip && <ErrorMessage id="zip-error">{this.state.validationErrors.zip}</ErrorMessage>}
                    </label>
                    <input type="hidden" name="school_id" value={(school || {})["Id"] || ""} />
                    {schoolView}
                  </div>
                  <div className={cx("mt-12", this.hideButton() && "hide")}>
                    {this.state.submitAttempted && !this.isValid() && (
                      <div className="mb-4">
                        {this.state.validationErrors.school && (
                          <ErrorMessage id="school-selection-error" className="text-left">
                            {this.state.validationErrors.school}
                          </ErrorMessage>
                        )}
                      </div>
                    )}
                    <PrimaryButton className="w-full" type="submit">
                      Continue
                    </PrimaryButton>
                  </div>
                </form>
              </div>
            </shared.Panel>
          </shared.Main>
        </shared.Page>
      </DocumentTitle>
    )
  }
})
